var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRejectX = function SvgRejectX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3236",
    d: "M.61 1.14a.375.375 0 0 1 .53-.53L5 4.47 8.86.61a.375.375 0 1 1 .53.53L5.53 5l3.86 3.86a.375.375 0 0 1-.53.53L5 5.53 1.14 9.39a.375.375 0 0 1-.53-.53L4.47 5z"
  })));
};
export default SvgRejectX;